var _path, _path2, _rect, _rect2, _rect3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVehicleRegistration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72,
  height: 49,
  viewBox: "0 0 72 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M36 2V1H35H6C3.23858 1 1 3.23858 1 6V43C1 45.7614 3.23858 48 6 48H35H36V47V2Z",
  stroke: "currentColor",
  strokeWidth: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M37 1H36V2V24.5642V47V48H37H66C68.7614 48 71 45.7614 71 43V6C71 3.23858 68.7614 1 66 1H37Z",
  stroke: "currentColor",
  strokeWidth: 2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 9,
  width: 19,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 14,
  width: 15,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 19,
  width: 12,
  height: 2,
  rx: 1,
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.5335 21.548C48.7915 20.6036 49.6234 19.9927 50.4352 20.0064C50.7912 19.9995 52.3544 19.9995 53.9981 20.0004C55.6418 19.9995 57.205 19.9995 57.561 20.0064C58.3728 19.9927 59.2047 20.6036 59.4628 21.548L60.097 23.8725C60.5562 23.8982 60.9219 24.272 60.9219 24.73C60.9219 25.0299 60.7644 25.2946 60.5265 25.4484C60.816 25.7036 60.9962 26.0568 60.9962 26.4512V27.7402C60.9962 27.9413 60.949 28.1312 60.8659 28.3005C60.7688 28.4913 60.7732 28.7164 60.8764 28.9037C60.9551 29.0343 60.9962 29.1882 60.9962 29.3514C60.9962 29.8481 60.6131 30.258 60.1215 30.3121V30.7478C60.1215 31.4585 59.5336 32.0368 58.8093 32.0368C58.085 32.0368 57.4972 31.4585 57.4972 30.7478V30.3572H50.4991V30.7478C50.4991 31.4585 49.9112 32.0368 49.1869 32.0368C48.4626 32.0368 47.8748 31.4585 47.8748 30.7478V30.3121C47.3831 30.258 47 29.8481 47 29.3514C47 29.1882 47.0411 29.0352 47.1137 28.9003C47.2152 28.7147 47.2187 28.493 47.1225 28.3039C47.0472 28.1312 47 27.9404 47 27.7402V26.4512C47 26.0637 47.1741 25.7165 47.4488 25.4802C47.1811 25.3333 47 25.0523 47 24.73C47 24.2557 47.3919 23.8716 47.8739 23.8716L48.5335 21.548ZM49.6563 26.8581C50.1199 26.8581 50.4961 27.2343 50.4961 27.6979C50.4961 28.1615 50.1199 28.5377 49.6563 28.5377C49.1928 28.5377 48.8166 28.1615 48.8166 27.6979C48.8166 27.2343 49.1928 26.8581 49.6563 26.8581ZM58.3368 26.8581C58.8004 26.8581 59.1766 27.2343 59.1766 27.6979C59.1766 28.1615 58.8004 28.5377 58.3368 28.5377C57.8733 28.5377 57.4971 28.1615 57.4971 27.6979C57.4971 27.2343 57.8733 26.8581 58.3368 26.8581ZM57.4972 25.0386H57.9426C58.108 25.0386 58.2647 24.9639 58.3653 24.8379C58.4668 24.7119 58.5001 24.5473 58.4572 24.3937C58.2647 23.7017 57.9637 22.6259 57.8053 22.0582C57.7431 21.8349 57.5313 21.6795 57.2898 21.6795H53.9967H50.7036C50.4621 21.6795 50.2503 21.8349 50.1882 22.0582C50.0298 22.6259 49.7287 23.7017 49.5362 24.3937C49.4933 24.5473 49.5266 24.7119 49.6281 24.8379C49.7287 24.9639 49.8854 25.0386 50.0508 25.0386H50.4962C51.0055 25.0369 56.9879 25.0369 57.4972 25.0386Z",
  fill: "currentColor"
})));
export { SvgVehicleRegistration as ReactComponent };